import PropTypes from "prop-types";
import React from "react";

import { GroupedRow, GroupedRowPropTypes } from "../GroupedRow";
import { List } from "../List";
import styles from "./GroupedRowList.module.scss";

/**
 * GroupedRowList renders a list of GroupedRow components with the ability to globally apply
 * GroupedRow prop transformations to all items.
 */
export const GroupedRowList = (props) => {
  const { className, items, light, size, spacing = 16, styleType } = props;

  return (
    <div className={className} style={{ "--spacing": spacing }}>
      <List {...getProps()} />
    </div>
  );

  function renderGroupedRow(item) {
    const groupedRowProps = getGroupedRowProps(item);

    return <GroupedRow {...groupedRowProps}>{groupedRowProps.children}</GroupedRow>;
  }

  function getProps() {
    return {
      className: styles.groupedRowList,
      items: items.map(renderGroupedRow),
    };
  }

  function getGroupedRowProps(item) {
    return {
      children: item.children,
      light: item?.light ?? light,
      size: item?.size ?? size,
      styleType: item?.styleType ?? styleType,
      title: item.title,
    };
  }
};

GroupedRowList.displayName = "GroupedRowList";

GroupedRowList.propTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** List of GroupedRow items to be rendered. Each GroupedRow can be edited independently. */
  items: PropTypes.arrayOf(PropTypes.shape(GroupedRowPropTypes)).isRequired,

  /** Provide light styling to accommodate rendering on a dark background. */
  light: PropTypes.bool,

  /** Size to be applied to both the title and the child content of all items. */
  size: PropTypes.oneOf(["large", "small"]),

  /** Spacing value between items, used as a CSS value in pixels. */
  spacing: PropTypes.number,

  /** Styling applied to all item text, using a faint shade, typically gray. */
  styleType: PropTypes.oneOf(["normal", "subtle", "subtleValue"]),
};
